import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Carousel from '@nerdwallet/react-carousel';

import { CenteredContainer } from '@nerdwallet/currency';

import NerdCarouselTile from './nerd-carousel-tile';

import styles from './carousel.module.less';

const NerdCarousel = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, id) => (
    <NerdCarouselTile {...tile} key={id} />
  ));

  return (
    <CenteredContainer className={styles.nerdCarouselContainer}>
      <div className="nerd-carousel">
        <Carousel
          id="nerd-carousel"
          autoplay={false}
          allowLooping
          decorateNav={false}
          enableDotNavigation
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          className={styles.nerdCarousel}
        >
          {renderedTiles}
        </Carousel>
      </div>
    </CenteredContainer>
  );
};

NerdCarousel.displayName = 'Meet Nerds';

NerdCarousel.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(NerdCarousel.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
};

export default NerdCarousel;
